/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { camelCase, cloneDeep, uniqueId } from 'lodash';
import Access from 'constants/Access';

function handleInitialAdjustments({
  questionnaire,
  setFieldValue,
  globalQuestionnaire,
  accessRoleData,
  rolesData,
  setRolesGroup,
  setRootRoles,
}) {
  try {
    const initialRoles = handleGroup({
      questionnaire,
      setFieldValue,
      globalQuestionnaire,
      accessRoleData,
      rolesData,
      setRolesGroup,
      setRootRoles,
    });
    const newRolesGroup = initialRoles.map((role, index) => {
        return {
          ...role,
          groups: [...role.groups],
          groupRoot: role.groupRoot.map(qst => {
            if (qst.idQuestion === 1973) {
              const activeGroupRoot = role.groups.some(group => group[2].idAnswerOption === 7617);

              const optionToBeSelected = activeGroupRoot ? 7617: 7616;

              const selectedOption = qst.answerOptions.find(option => option.idAnswerOption === optionToBeSelected);
              const result = {
                idAnswerOption: selectedOption?.idAnswerOption,
                dsAnswerOption: selectedOption?.dsAnswerOption,
                resultValue: selectedOption?.behaviorObject?.resultValue || null
              };

              qst.answer = selectedOption?.dsAnswerOption;
              qst.answerJson = selectedOption.answerJson;
              qst.idAnswerOption = selectedOption?.idAnswerOption;
              setFieldValue && setFieldValue(qst.key, result);

            }
            return qst;
          }),
          checked: role.groupRoot.find(qst => qst.idQuestion === 1973).idAnswerOption === 7617
        }
    })

    return newRolesGroup

  } catch (e) {
    console.log("ROLE - handleInitialAdjustments error", e)
  }
}

function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  setRolesGroup,
  rolesGroup,
  rootRoleIndex
}) {
  try {
    let saveFilteredQuestionnaire = false;
    if (question.idQuestion === 1973) {
      const selectedOption = question.answerOptions.find(option => option.idAnswerOption === value.idAnswerOption);
      const result = {
        idAnswerOption: selectedOption?.idAnswerOption,
        dsAnswerOption: selectedOption?.dsAnswerOption,
        resultValue: selectedOption?.behaviorObject?.resultValue || null
      };

      question.answer = selectedOption?.dsAnswerOption;
      question.answerJson = selectedOption.answerJson;
      question.idAnswerOption = selectedOption?.idAnswerOption;
      setFieldValue && setFieldValue(question.key, result);

      if (rolesGroup) {
        const newRolesGroup = rolesGroup.map((role, index) => {
            if (index === rootRoleIndex) {
              return {
                ...role,
                groups: [...role.groups],
                groupRoot: role.groupRoot.map(qst => {
                  if (qst.idQuestion === 1973) {
                    const activeGroupRoot = role.groups.some(group => group[2].idAnswerOption === 7617);

                    const optionToBeSelected = activeGroupRoot ? 7617: 7616;

                    const selectedOption = qst.answerOptions.find(option => option.idAnswerOption === optionToBeSelected);
                    const result = {
                      idAnswerOption: selectedOption?.idAnswerOption,
                      dsAnswerOption: selectedOption?.dsAnswerOption,
                      resultValue: selectedOption?.behaviorObject?.resultValue || null
                    };

                    qst.answer = selectedOption?.dsAnswerOption;
                    qst.answerJson = selectedOption.answerJson;
                    qst.idAnswerOption = selectedOption?.idAnswerOption;
                    setFieldValue && setFieldValue(qst.key, result);
     
                  }
                  return qst;
                }),
                checked: role.groupRoot.find(qst => qst.idQuestion === 1973).idAnswerOption === 7617
              }
            }
            return role;
          })
        setRolesGroup(newRolesGroup);
      }
    }

    if (saveFilteredQuestionnaire) setQuestionnaire(questionnaireUpdated);
  } catch (e) {
    console.log("ROLE - handleQuestionChange error", e)
  }
}

async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
  } catch (e) {
    console.log('ROLE - handleRequestSerproCnpj error', e)
  }
};

function handleGroup({
  questionnaire,
  setFieldValue,
  accessRoleData,
  rolesData,
}) {
  try {
    const groups = [];
    const childRoles = rolesData
      .filter((role) => role.idDomainRoot !== null)
      .sort((a, b) => a.idDomainRoot - b.idDomainRoot)

    const baseGroup = cloneDeep(questionnaire[0]);

    childRoles.map((role, index) => {
      const newGroup = baseGroup.map((qst) => {
        qst = cloneDeep(qst);
        qst.key = `${camelCase(qst.dsQuestion)}_${qst.idQuestion}${uniqueId()}_${uniqueId()}`;
        qst.idQuestionnaireAnswers = null;
        qst.idQuestionnaireAnswersParent = null;
        qst.idQuestionnaireAnswersRoot = null;
        qst.answer = null;
        qst.idAnswerOption = null;

        if (qst.idQuestion === 1971) {
          qst.visibleQuestion = false;
          qst.answer = role.idDomainRoot;
          qst.label = role.domainRootTranslatedDescription || role.domainDescription || ''
        }

        if (qst.idQuestion === 1972) {
          qst.visibleQuestion = false;
          if (role.idDomain === 1007) role.idDomain = Access.APLICATION;
          qst.answer = role.idDomain;
          qst.label = role.domainTranslatedDescription || role.domainDescription || ''
        }

        if (qst.idQuestion === 1973) {
          if (accessRoleData) {
            const isSelectedPrivilege = accessRoleData.accessRoleItem?.some((item) => {
              return item.idDomainObjectType === role.idDomain || 
              ( item.idDomainObjectType === accessRoleData.idDomain && role.idDomain === 1007 )  });
            const selectedOption = qst.answerOptions.find(option => option.idAnswerOption === (isSelectedPrivilege ? 7617 : 7616));

            const result = {
              idAnswerOption: selectedOption?.idAnswerOption,
              dsAnswerOption: selectedOption?.dsAnswerOption,
              resultValue: selectedOption?.behaviorObject?.resultValue || null
            };

            qst.answer = selectedOption?.dsAnswerOption;
            qst.answerJson = selectedOption.answerJson;
            qst.idAnswerOption = selectedOption?.idAnswerOption;
            setFieldValue && setFieldValue(qst.key, result);
          }
        }

        if ([1974].includes(qst.idQuestion)) {
          qst.visibleQuestion = false;
        }

        if (qst.key) setFieldValue(qst.key, String(qst.answer));
        return qst;
      })

      groups.push(newGroup)
    })

    let rootRoles = rolesData.filter((role) => role.idDomainRoot === null);

    rootRoles = rootRoles.map((role) => {
      return {
        ...role,
        groups: groups.filter((group) => group[0].answer === role.idDomain)
      }
    })

    rootRoles = rootRoles.filter((role) => role.groups.length > 0);

    rootRoles = rootRoles.map((role) => {
      let groupRoot = cloneDeep(questionnaire[0]);
      groupRoot = groupRoot.map(qst => {
        qst.key = `${camelCase(qst.dsQuestion)}_${qst.idQuestion}${uniqueId()}_${uniqueId()}`;
        qst.idQuestionnaireAnswers = null;
        qst.idQuestionnaireAnswersParent = null;
        qst.idQuestionnaireAnswersRoot = null;
        qst.answer = null;
        qst.idAnswerOption = null;

        if (qst.idQuestion === 1971) {
          qst.answer = role.idDomain;
          qst.label = role.domainRootTranslatedDescription || role.domainDescription || ''
        }

        if (qst.idQuestion === 1972) {
          qst.answer = role.idDomain;
          qst.label = role.domainTranslatedDescription || role.domainDescription || ''
        }

        if (qst.idQuestion === 1973) {
          if (accessRoleData) {
            const isSelectedPrivilege = accessRoleData.accessRoleItem?.some(
              (item) => item.idDomainObjectType === role.idDomain
            );
            const selectedOption = qst.answerOptions.find(
              option => option.idAnswerOption === (isSelectedPrivilege ? 7617 : 7616)
            );

            const result = {
              idAnswerOption: selectedOption?.idAnswerOption,
              dsAnswerOption: selectedOption?.dsAnswerOption,
              resultValue: selectedOption?.behaviorObject?.resultValue || null
            };

            qst.answer = selectedOption?.dsAnswerOption;
            qst.answerJson = selectedOption.answerJson;
            qst.idAnswerOption = selectedOption?.idAnswerOption;
            setFieldValue && setFieldValue(qst.key, result);
          }
        }

        qst.visibleQuestion = false;

        if (qst.key) setFieldValue(qst.key, String(qst.answer));
        return qst;
      });
      
      return {
        ...role,
        checked: groupRoot.find(qst => qst.idQuestion === 1973).idAnswerOption === 7617,
        groupRoot
      }
    })

    return rootRoles;
  } catch (e) {
    console.log('ROLE - handleGroup error', e)
  }
}

function handleSwitchGroupChange({
  setFieldValue,
  checked,
  rootRoleIndex,
  setRolesGroup,
}) {
  try {
    setRolesGroup((prev) => {
      const newRolesGroup = prev.map((role, index) => {
        if (index === rootRoleIndex) {
          return {
            ...role,
            checked: checked,
            groups: role.groups.map((group) => {
              return group.map((qst) => {
                qst = cloneDeep(qst);

                if (qst.idQuestion === 1973) {
                  const selectedOption = qst.answerOptions.find(option => option.idAnswerOption === (checked ? 7617 : 7616));
                  const result = {
                    idAnswerOption: selectedOption?.idAnswerOption,
                    dsAnswerOption: selectedOption?.dsAnswerOption,
                    resultValue: selectedOption?.behaviorObject?.resultValue || null
                  };

                  qst.answer = selectedOption?.dsAnswerOption;
                  qst.answerJson = selectedOption.answerJson;
                  qst.idAnswerOption = selectedOption?.idAnswerOption;
                  setFieldValue && setFieldValue(qst.key, result);
                }
                return qst;
              })
            }),
            groupRoot: role.groupRoot.map(qst => {
              if (qst.idQuestion === 1973) {
                const selectedOption = qst.answerOptions.find(option => option.idAnswerOption === (checked ? 7617 : 7616));
                const result = {
                  idAnswerOption: selectedOption?.idAnswerOption,
                  dsAnswerOption: selectedOption?.dsAnswerOption,
                  resultValue: selectedOption?.behaviorObject?.resultValue || null
                };

                qst.answer = selectedOption?.dsAnswerOption;
                qst.answerJson = selectedOption.answerJson;
                qst.idAnswerOption = selectedOption?.idAnswerOption;
                setFieldValue && setFieldValue(qst.key, result);
              }
              return qst;
            })
          }
        }
        return role;
      })

      return newRolesGroup
    })

  } catch (e) {
    console.log('ROLE - handleSwitchGroup error', e)
  }
}

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleRequestSerproCnpj,
  handleSwitchGroupChange,
}

export { events };